export default __webpack_public_path__ + "static/epilogue-9d34c7e58c5629d49e3ce0762a1b6e02.svg";